import { render } from "./PaginaErro.vue?vue&type=template&id=9782fd6c&scoped=true"
const script = {}

import "./PaginaErro.vue?vue&type=style&index=0&id=9782fd6c&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9782fd6c"]])

export default __exports__